<p>
  view-all-ratings-v2 works!
</p>
